import { CircularProgress, LinearProgress } from '@mui/material';

interface LoadingIndicatorProps {
  isLoading?: boolean;
  isSpinner?: boolean;
}

const Spinner = () => {
  return (
    <>
      <div style={{}} className="loadSpinnerContainer">
        <CircularProgress />
      </div>
    </>
  );
};

export const LoadingIndicator = ({ isLoading, isSpinner }: LoadingIndicatorProps) => {
  if (!isLoading) {
    return null;
  }
  if (isSpinner) {
    return <Spinner />;
  }
  return <LinearProgress />;
};
